import { AgRendererComponent } from 'ag-grid-angular';
import { Component, OnDestroy, ChangeDetectorRef } from '@angular/core';

import { ICellRendererParams } from 'ag-grid-community';
import { Primitive } from '@geniuspos/ui-shared';
import { isObservable, Observable, of, Subscription } from 'rxjs';
import { forEach, get, isFunction, isEqual } from 'lodash';
import { distinctUntilChanged } from 'rxjs/operators';
import { observableCombineLatest } from '@shared/rx';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-specific-data-renderer',
  templateUrl: './specific-data-renderer.component.html',
  styleUrls: ['./specific-data-renderer.component.scss'],
})
export class XVISpecificDataRenderer implements AgRendererComponent, OnDestroy {
  public value?: Primitive;
  public isBusy: boolean = false;
  public subscriptions: Subscription[] = [];

  public constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  public async agInit(rendererParams: ICellRendererParams): Promise<void> {
    // is get renderer params in root level(rendererParams)
    const isRendererParamsInTheRoot = get(
      rendererParams,
      'isRendererParamsInTheRoot',
      false,
    );
    const {
      isBusy,
      dataSource,
      filterFn,
      valueMapper,
      rowDataPath = 'data',
    } = isRendererParamsInTheRoot
      ? rendererParams
      : get(rendererParams, ['colDef', 'cellRendererParams'], {} as any);

    const isBusy$ = (
      isObservable(isBusy) ? isBusy : of(isBusy)
    ) as Observable<boolean>;
    const dataSource$ = isObservable(dataSource) ? dataSource : of(dataSource);
    this.subscriptions.push(
      observableCombineLatest([isBusy$, dataSource$])
        .pipe(distinctUntilChanged())
        .subscribe(([busyStatus, data]) => {
          const statusChanged = !isEqual(this.isBusy, busyStatus);
          this.isBusy = busyStatus;

          if (statusChanged) {
            this.changeDetectorRef.markForCheck();
          }

          if (this.isBusy) return;

          let filteredData = data;

          const rowData = get(rendererParams, rowDataPath);

          if (isFunction(filterFn)) {
            filteredData = filterFn(filteredData, rowData);
          }

          const newValue = isFunction(valueMapper)
            ? valueMapper(filteredData, rowData)
            : filteredData;

          const valueChanged = !isEqual(this.value, newValue);

          this.value = newValue;

          if (valueChanged) {
            this.changeDetectorRef.markForCheck();
          }
        }),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public refresh(params: any): boolean {
    return false;
  }

  public ngOnDestroy(): void {
    forEach(this.subscriptions, (subscribe) => subscribe.unsubscribe());
    this.subscriptions = [];
  }
}
